import { dispatchSelectedAddress, dispatchSelectedPostalLocation, dispatchShopCar } from '@/redux/action';
import { buildSelectedAddressPayload, setStoredSelectedAddress } from '@/util/addressSelection';
import { isGuest } from '@/util/commonUtils';
import { refreshHeaderAddress } from '@/util/headerAddressConfig';
import { getStoredPostalCodeLocation } from '@/util/postalCodeAddress';

let sessionBootstrapped = false;
let sessionBootstrapInflight: Promise<void> | null = null;

/** 401 / 退出登录时重置，允许下次登录重新 bootstrap */
export function resetSessionBootstrap() {
  sessionBootstrapped = false;
  sessionBootstrapInflight = null;
}

/**
 * 登录会话级初始化：购物车数、头部地址等全站只需拉一次。
 * NavBar remount 不应重复触发；API 层缓存仅作并发兜底。
 */
export function bootstrapLoggedInSession(dispatch: (action: unknown) => void): Promise<void> {
  if (sessionBootstrapped || isGuest()) {
    return Promise.resolve();
  }

  if (sessionBootstrapInflight) {
    return sessionBootstrapInflight;
  }

  sessionBootstrapInflight = (async () => {
    try {
      const storedPostalLocation = getStoredPostalCodeLocation();
      if (storedPostalLocation) {
        dispatch(dispatchSelectedPostalLocation(storedPostalLocation));
      }
      await Promise.all([
        dispatch(dispatchShopCar()),
        (async () => {
          const result = await refreshHeaderAddress();
          if (!result.selected) {
            return;
          }

          const selectedAddress = buildSelectedAddressPayload(result.selected, result.selectedSource);
          if (!selectedAddress) {
            return;
          }

          setStoredSelectedAddress(selectedAddress);
          dispatch(dispatchSelectedAddress(selectedAddress));
        })(),
      ]);
      sessionBootstrapped = true;
    } catch (error) {
      console.error('bootstrapLoggedInSession failed', error);
    } finally {
      sessionBootstrapInflight = null;
    }
  })();

  return sessionBootstrapInflight;
}
